export class Checkout {
  customer?: string
  ephemeralKey?: string
  paymentIntent?: string
  constructor(params?: Partial<Checkout>) {
    Object.assign(this, params)
  }
}
